// extracted by mini-css-extract-plugin
module.exports = {"setp-wrap":"header_style_setp-wrap__188W8","step":"header_style_step__CZWiA"};